import { render } from "./IspeksManual.vue?vue&type=template&id=4989787b"
import script from "./IspeksManual.vue?vue&type=script&lang=js"
export * from "./IspeksManual.vue?vue&type=script&lang=js"

import "./IspeksManual.vue?vue&type=style&index=0&id=4989787b&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__